import ApplicationSerializer from 'lumen/serializers/application';

export default class CapacitySerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(key: string): string {
    if (key === 'data') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('budget-forecast/capacity');
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }
}
